import { Button, ButtonVariant, Intent, Tag, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore,  } from "src/modules/pe-landing-module/data/store" 
import { setCursor } from "."
import edit_tool from "../../../../assets/img/edit-tool.svg"

/* Protopia Ecosystem component */
export interface IDragToolProps {
   
}
const EditTool = (props: IDragToolProps): JSX.Element => {
    const editMode = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode)
    const setEdit = () => {
        useLandingConsoleStore.setState({ editMode: LANDING_EDIT_MODE.EDIT })
        setCursor("default")
    }
    const isEdit = editMode === LANDING_EDIT_MODE.EDIT
    return <Tooltip 
        content={ <div className="small letter-spacing-1 flex-centered">
            {__( "Edit" )}
            <Tag minimal className="ml-2 px-2 py-0"><div className="smallest text-light title">CTRL + E</div></Tag>
        </div> } 
        className=" ml-auto" 
        position="right"
        intent={Intent.PRIMARY}
        compact
        hoverOpenDelay={600}
        portalClassName="z-index-90"
        modifiers={{ 
            arrow: { enabled: true },
            flip: { enabled: true },
            preventOverflow: { enabled: false },
            offset: { 
                enabled: true, 
                options: {
                    offset: [0, 2],
                } 
            }, 
        }}
    >
        <Button variant={ isEdit ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} onClick={ setEdit } >
            <div className={`d-flex flex-column align-items-center ${isEdit ? "" : "opacity_5"}`}>
                <img src={edit_tool} alt="" height={15} className="panel-icon" /> 
            </div>
        </Button>
    </Tooltip>
}
export default EditTool